//
//
//
//
//
//
//
//
//
export default {
  data: function data() {
    return {
      data: []
    };
  },
  methods: {}
};